'use client';

import React from 'react';

import { type MultiLevelMenuItem } from '@/common/types/multi-level-menu.type';
import { type FilteredDataType } from '@/features/store/types/filter.type';

import { stringFilters } from '@/common/utils/stringFilters.utility';

import FilterTags from './filter-tags.component';

export interface CollectionInfoProps {
  className?: string;
  title: string;
  onSearch: (value: string) => void;
  categoryList: MultiLevelMenuItem[];
  filteredData: FilteredDataType;
}

export default function CollectionInfo({
  title,
  categoryList,
  filteredData,
  onSearch,
  className = '',
}: CollectionInfoProps) {
  return (
    <div
      className={`hidden w-full flex-row items-center justify-between py-4 lg:mt-4 lg:flex ${className}`}
    >
      <div className="flex grow flex-col justify-start pt-1">
        <h2 className="text-nowrap text-sm font-semibold text-black-default lg:!text-lg lg:!font-semibold ">
          محصولات کالکشن {stringFilters(title, { removeEmojis: true })}
        </h2>
        <FilterTags
          allCategories={categoryList}
          filteredData={filteredData}
          onSearch={onSearch}
        />
      </div>
    </div>
  );
}
